import { useEffect, useRef } from "react";
import { Alert, AlertTitle, Stack } from "@mui/material";

/**
 * UX brief §State 5. Replaces the entire card body. NO "Sign in" button is
 * rendered — AC8 asserts the button count is 0. Auto-focused on mount.
 */
export function UnknownTenantAlert() {
  const ref = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    ref.current?.focus();
  }, []);

  return (
    <Stack spacing={2} sx={{ width: "100%", maxWidth: 480 }}>
      <Alert
        ref={ref}
        tabIndex={-1}
        severity="error"
        role="alert"
        variant="outlined"
      >
        <AlertTitle>Unknown tenant</AlertTitle>
        We couldn&apos;t find a tenant for this URL. Check the address bar — it
        should look like <code>&lt;your-tenant&gt;.windplatform.com</code>. If
        the URL is correct, contact your tenant admin.
      </Alert>
    </Stack>
  );
}
